import { firestore, storage } from "../firebase";
const state = {
  datosUsuario: null,
  proyectosUsuario: [],
  infoUsuario: {},
  projectsUserListener: () => {},
};
const mutations = {
  informacionUsuario(state, datos) {
    state.datosUsuario = datos;
  },
  obtenerProyectosUser(state, proyectos) {
    state.proyectosUsuario = proyectos;
  },
  infoUsuario(state, info) {
    state.infoUsuario = info;
  },
  setProjectsUserListener(state, listener) {
    if (listener) {
      //si listener tiene algo se agrega al estado
      state.listener = listener;
    } else {
      //si no, se lanza la funcion
      state.projectsUserListener();
    }
  },
};
const actions = {
  async obtenerUsuario({ commit, rootState }) {
    const uidDoc = rootState.autenticacion.usuario.uid;
    const documento = firestore.collection("usuarios").doc(uidDoc);
    documento.get().then((doc) => {
      if (doc.exists) {
        commit("informacionUsuario", doc.data());
      } else {
        console.log("No existe el documento");
      }
    });
  },

  limpiarStore({ commit }) {
    commit("informacionUsuario", null);
  },

  async obtenerProyectosUsuario({ commit, rootState }) {
    const proyectos = [];
    const uidUser = rootState.autenticacion.usuario.uid;
    const proyectosfirestore = await firestore
      .collection("usuarios")
      .doc(uidUser)
      .collection("proyectos_usuario")
      .get();
    proyectosfirestore.docs.forEach((doc) => {
      const proyecto = doc.data();
      proyecto.id = doc.id;
      proyectos.push(proyecto);
    });

    commit("obtenerProyectosUser", proyectos);
  },

  async informacionAUsuario(
    { commit },
    { nombreUsuario, emailUsuario, areaUsuario }
  ) {
    let callToAction = await firestore
      .collection("informar_areas_nuevas")
      .doc(nombreUsuario)
      .set({
        nombre: nombreUsuario,
        email: emailUsuario,
        area: areaUsuario,
      });
    commit("infoUsuario", callToAction);
    console.log("te avisaremos cuando el area este disponible");
  },

  /* proyecto terminado, actualizacion */
  async fotoDePerfil(context, { imagen, idUsuario, nombre }) {
    const uploadPhoto = () => {
      let direccion = `usuarios/${idUsuario}/${nombre}-image.png`;
      return storage.ref(direccion).put(imagen);
    };

    function getDownloaderURL(ref) {
      return ref.getDownloadURL();
    }

    try {
      let upload = await uploadPhoto();
      return await getDownloaderURL(upload.ref);
    } catch (error) {
      console.log(error);
    }
  },
  async actualizarPerfil(
    context,
    {
      idUsuario,
      nombre,
      apellidos,
      username,
      pais,
      descripcion,
      linkedin,
      behance,
      dribbble,
      instagram,
      twitter,
      github,
      web,
      foto,
      areaDesempeño,
      especializacion,
    }
  ) {
    const datosActualizados = {};
    if (nombre) {
      datosActualizados.nombre = nombre;
    }
    if (descripcion) {
      datosActualizados.descripcion = descripcion;
    }
    if (apellidos) {
      datosActualizados.apellidos = apellidos;
    }
    if (username) {
      datosActualizados.nombreUsuario = username;
    }
    if (pais) {
      datosActualizados.pais = pais;
    }
    if (linkedin) {
      datosActualizados.linkedin = linkedin;
    }
    if (behance) {
      datosActualizados.behance = behance;
    }
    if (dribbble) {
      datosActualizados.dribbble = dribbble;
    }
    if (instagram) {
      datosActualizados.instagram = instagram;
    }
    if (twitter) {
      datosActualizados.twitter = twitter;
    }
    if (github) {
      datosActualizados.github = github;
    }
    if (web) {
      datosActualizados.web = web;
    }
    if (foto != "") {
      datosActualizados.foto = foto;
    }
    if (areaDesempeño.length > 0) {
      datosActualizados.areaDesempeño = areaDesempeño;
      datosActualizados.especializacion = especializacion;
    }
    await firestore
      .collection("usuarios")
      .doc(idUsuario)
      .update(datosActualizados);
  },


  async actualizarAEstudiante(context, { idUsuario, codigo }) {
    const datosActualizados = {};
    datosActualizados.codigoDelCurso = codigo;
    await firestore
      .collection("usuarios")
      .doc(idUsuario)
      .update(datosActualizados);
  },
};

const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
